import React from "react";

import { Button, Card, Col, Container, Row, Stack } from "react-bootstrap";

import { Link } from "react-router-dom";
import { ROUTES } from "src/routes";

import { PlusIcon } from "@assets/icons";
import { IconButton } from "@components/IconButton";
import { UserDisplay } from "@components/UserDisplay";
import { ProtectedComponent } from "@components/permission_control/ProtectedComponent";
import { useAuthenticationContext } from "@context/authentication";
import { Role } from "@roles";

import { BouncedPaymentParticipants } from "./BouncedPaymentParticipants";
import { PendingApproval } from "./PendingApproval";
import { PendingApprovalUsersList } from "./PendingApprovalUsersList";
import { SearchBar } from "./SearchUser";

import styles from "./index.module.scss";

export const Accounts = () => {
  const { auth } = useAuthenticationContext();
  return (
    <>
      <Container className="p-4" fluid>
        <Stack direction="vertical">
          <Row className="pb-4 px-4">
            <Col className="px-0">
              <UserDisplay />
            </Col>
            <Col className="d-flex flex-row flex-wrap justify-content-end px-0">
              <Card bg="info" className={styles["card"]}>
                <Card.Body className="d-flex gap-3 align-items-center">
                  <Button variant="none">
                    <Link className={styles["link"]} to={ROUTES.Dashboard.NewAccounts.UserRole.path}>
                      <IconButton variant="quaternary" src={PlusIcon}></IconButton>
                    </Link>
                  </Button>
                  <Card.Title>Create account</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex flex-row flex-wrap p-4 pb-0">
              <SearchBar />
            </Col>
          </Row>
          <Row>
            <PendingApproval />
          </Row>
          <ProtectedComponent requiredGroups={[Role.VisualArtistAdmin, Role.MemberServices]} auth={auth}>
            <Row>
              <PendingApprovalUsersList />
            </Row>
            <Row>
              <BouncedPaymentParticipants />
            </Row>
          </ProtectedComponent>
        </Stack>
      </Container>
    </>
  );
};
